
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {Project} from '../../types/interfaces/project.interface';
import { HttpClient } from '@angular/common/http';
import {ProjectInfo} from "@webmate-web-core/shared/types/projectInfo";

@Injectable({
  providedIn: 'root'
})
export class ProjectApi {

    constructor (public OAuth2AuthService: AuthService, private http: HttpClient) { }

    getProject(projectId: string): Observable<Project> {
        return this.http.get<Project>('/projects/' + projectId);
    }

    getProjectsForCurrentUser(): Observable<ProjectInfo[]> {
        return this.http.get<ProjectInfo[]>('/projects/');
    }

}
